import React, { useState, useEffect } from "react";
import { Container, Typography, Button } from "@mui/material";

const Hero = () => {
  const images = ["img1.png", "img2.png", "img3.png"]; // Rutas de las imágenes
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Cambiar de imagen cada 3 segundos

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
  }, [images.length]);

  return (
    <div
      style={{
        position: "relative",
        height: "60vh",
        overflow: "hidden", // Oculta las imágenes que se deslizan fuera del contenedor
        marginTop: "70px",
      }}
    >
      {images.map((image, index) => (
        <div
          key={index}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: currentImageIndex === index ? 1 : 0,
            transition: "opacity 1s ease-in-out", // Suaviza la transición
          }}
        />
      ))}

      <Container
        style={{
          position: "relative", // Para que el texto esté sobre las imágenes
          zIndex: 1, // Asegura que el texto esté por encima de las imágenes
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "white",
          textAlign: "center",
        }}
      >
        <Typography variant="h2" component="h1" gutterBottom>
          Soluciones Profesionales de Zinguería
        </Typography>
        <Typography variant="h5" gutterBottom>
          Mejora y protección para techos con productos de alta calidad
        </Typography>
        <Button
          variant="contained"
          href="#products"
          style={{
            transition: "background-color 0.3s, transform 0.3s",
            background: "#123A8A",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#123A8A"; // Cambia el color al pasar el mouse
            e.currentTarget.style.transform = "scale(1.05)"; // Efecto de zoom
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#123A8A"; // Restaura el color original
            e.currentTarget.style.transform = "scale(1)"; // Restaura el tamaño original
          }}
        >
          Ver más
        </Button>
      </Container>
    </div>
  );
};

export default Hero;
